<div data-test-id="taetigkeit">{{ body.taetigkeit | enumToLabel: zertifikatTaetigkeitLabel }}</div>

@if (hasVersandTaetigkeit) {
	<div data-test-id="empfaenger">{{ versandTaetigkeit }}</div>
}
@if (hasFaxEmpfaenger) {
	<div data-test-id="fax-empfaenger">und vorab per Fax an {{ faxEmpfaenger }}</div>
}
